import { render, staticRenderFns } from "./DotsAnimation.vue?vue&type=template&id=0143ea8d&scoped=true&"
import script from "./DotsAnimation.vue?vue&type=script&lang=js&"
export * from "./DotsAnimation.vue?vue&type=script&lang=js&"
import style0 from "./DotsAnimation.vue?vue&type=style&index=0&id=0143ea8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0143ea8d",
  null
  
)

export default component.exports